const getEnv = () => {
    return process.env;
};

export default getEnv;
